import { useState, useRef } from "react"
import ReactDOM from "react-dom";
import UserLister from "./userLister";
import AdminForm from "./adminForm";
import WildcardLister from "./wildcardLister";
import Loading from "../Loading";

export default function AdminQuery({displayRef, em, token}){
    const tableRef = useRef(null);
    const formRef = useRef(null)
    const [query , setQuery] = useState("");
    const [err, setErr] = useState("");


    function validateEmail(email) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    }

    let temp = {};
            
    const doChange = (e) => {
        e.preventDefault();
        setQuery(e.target.value); 
    }
    
    const doQuery = (e) => {
        e.preventDefault();

        if(!query.includes('@')){
            setErr(<h4>Invalid Email</h4>)
            return;
        }

        if(!validateEmail(query)){
            setErr(<li>Invalid Email</li>);
            return
        }

        setQuery("")

        try {    
            ReactDOM.render(<UserLister displayRef={displayRef} 
                query={query} em={em} token={token} />, 
                tableRef.current);
        } catch(err){
            alert(err)
        }
    } 

    const createNew = (e) => {
        e.preventDefault();

        try {    
            ReactDOM.render(<AdminForm temp={temp} em={em} token={token} />, 
                formRef.current);

        } catch(err){
            alert(err)
        }
    }
    const wildcardQuery = (e) => {
        e.preventDefault();

        if (!query || query.trim() === "") {
            setErr(<h4>Please enter a search term</h4>);
            return;
        }

        setErr("");

        try {    
            // 1. Immediately wipe out the old table data
            ReactDOM.unmountComponentAtNode(tableRef.current);
            ReactDOM.render(<Loading />, tableRef.current);

            setTimeout(() => {
                ReactDOM.render(
                    <WildcardLister 
                        key={Date.now()} 
                        displayRef={displayRef} 
                        tableRef={tableRef} 
                        query={query} 
                        em={em} 
                        token={token} 
                    />, 
                    tableRef.current
                );
            }, 50);

        } catch (err) {
            alert(err);
        }
    }
        
    return (
        <div  id="table"> 
            <div ref={formRef}>
            <div id='banner-search' >
                <h4>User Administration </h4>
            </div>
            
            <div style={{padding: "20px 20px 30px 20px"}}>
                <h5>Search Users by Email</h5>
                <br />
                <>{err}</>
                <label className="form-label"><h6>User Email:</h6></label>
                <br />
                <tr>
                    <th>
                    <input type="text"
                        className="form-control"
                        onChange={(e) => doChange(e)}
                        value={query} 
                        size="40"
                        name="query"
                    >
                    </input>
                      
                    </th>
                </tr>
                <button id="button"
                    onClick={(e)=> doQuery(e)}
                    style={{"textAlign": "start"}}
                    className="btn btn-primary" >Search
                </button>
                <button id="button"
                    onClick={(e) => createNew(e)}
                    style={{"textAlign": "start"}}
                    className="btn btn-primary">
                    Create New User
                </button>
                <button id="button"
                    onClick={(e) => wildcardQuery(e)}
                    style={{"textAlign": "start"}}
                    className="btn btn-primary">
                    Wildcard Search
                </button>
            </div>
            <center style={{ marginTop: "30px" }}>
                <div ref={tableRef}></div>
            </center>
            </div>
        </div>
    )
}